import React, { useEffect, useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import BASE_API_URL from "../../apis/index";
import axios from "axios";
import { Button } from "@mui/material";
import styled from "styled-components";

export default function CompServicesSection({ compId }) {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchServices() {
      try {
        setLoading(true);

        const authToken = localStorage.getItem("authToken");

        const res = await axios.get(
          `${BASE_API_URL}/api/buyer/company/services/${compId}`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setServices(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch services", err);
        setServices([]);
      } finally {
        setLoading(false);
      }
    }

    if (compId) fetchServices();
  }, [compId]);

  // ⛔ Do not render while loading
  if (loading) return null;

  // ⛔ If no services available
  if (!services.length) return null;

  return (
    <Wrapper className="py-md-5 p-5 rounded-5 bg-light my-5">
      <div className="border rounded-4 overflow-hidden">

        <h5 className="txt_color_primary fw-medium px-3 py-4 bg-light">
          Services - Contract Manufacturer Organisation
        </h5>

        {services.map((service, idx) => {
          const dosageFormats = safeParse(service?.dosage_formats);
          const specialities = safeParse(service?.specialities);
          const capabilities = safeParse(service?.capabilities);
          const packaging = safeParse(service?.packaging);
          const documents = safeParse(service?.document_names);

          return (
            <div key={idx}>

              {dosageFormats.length > 0 && (
                <Row label="Dosage Formats:">
                  {dosageFormats.map((item, i) => (
                    <div className="Pill" key={i}>{item}</div>
                  ))}
                </Row>
              )}

              {specialities.length > 0 && (
                <Row label="Specialities:">
                  {specialities.map((item, i) => (
                    <div className="Pill" key={i}>{item}</div>
                  ))}
                </Row>
              )}

              {capabilities.length > 0 && (
                <Row label="Capabilities:">
                  {capabilities.map((item, i) => (
                    <div className="Pill" key={i}>{item}</div>
                  ))}
                </Row>
              )}

              {packaging.length > 0 && (
                <Row label="Packaging:">
                  {packaging.map((item, i) => (
                    <div className="Pill" key={i}>{item}</div>
                  ))}
                </Row>
              )}

              {documents.length > 0 && (
                <Row label="Supporting Documents:">
                  {documents.map((item, i) => {
                    const fileUrl = `${BASE_API_URL}/uploads/user_srvc_docs/${item}`;
                    return (
                      <Button
                        key={i}
                        variant="outlined"
                        color="warning"
                        startIcon={<PictureAsPdfIcon />}
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          textTransform: "none",
                          borderRadius: "5px",
                          padding: "5px 12px",
                          fontSize: "14px",
                        }}
                      >
                        {item}
                      </Button>
                    );
                  })}
                </Row>
              )}

            </div>
          );
        })}

      </div>
    </Wrapper>
  );
}

/* ---------------------- Reusable Row ---------------------- */
function Row({ label, children }) {
  if (!children) return null;

  return (
    <div className="w-100 border-top">
      <div className="d-flex align-items-start">
        <div className="w-25 bg-white p-3 fw-medium">
          {label}
        </div>
        <div className="w-75 p-3 d-flex flex-wrap gap-2">
          {children}
        </div>
      </div>
    </div>
  );
}

/* ---------------------- Safe JSON Parse ---------------------- */
function safeParse(value) {
  try {
    const parsed = JSON.parse(value || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/* ---------------------- Styles ---------------------- */
const Wrapper = styled.div`
  .Pill {
    background: white;
    padding: 7px 15px;
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid #eee;
  }
`;